import { Navigate } from 'react-router-dom';
import HVworkPermits from '../../../modules/superAdmin/HVworkPermits';
import PlantSafetyRegulation from '../../../modules/superAdmin/PlantSafetyRegulation';
import Reports from '../../../modules/superAdmin/Reports';
import Settings from '../../../modules/superAdmin/Settings';
import HVworkPermitDetails from '../../../modules/superAdmin/HVworkPermits/HVworkPermitDetails';
import PlantSafetyWorkPermitDetail from '../../../modules/superAdmin/PlantSafetyRegulation/PlantSafetyWorkPermitDetail';
import HotWorkApproval from '../../../modules/superAdmin/HotWorkApproval';
import HotWorkApprovalDetail from '../../../modules/superAdmin/HotWorkApproval/HotWorkApprovalDetail';
import NotificationList from '../../../modules/superAdmin/Settings/NotificationList';
import UserInfo from '../../../modules/superAdmin/Settings/UserInfo';
import PasswordSecurity from '../../../modules/superAdmin/Settings/PasswordSecurity';
import PrivacyPolicy from '../../../modules/superAdmin/Settings/PrivacyPolicy';

const routes = [
  {
    path: '/HotWorkApproval',
    element: <HotWorkApproval />,
  },
  {
    path: '/HotWorkApproval/:id',
    element: <HotWorkApprovalDetail />,
  },
  {
    path: '/Report',
    element: <Reports />,
  },
  {
    path: '/settings',
    element: <Settings />,
    children: [
      //{ index: true, element: <UserInfo /> },
      { path: 'user-info', element: <UserInfo /> },
      { path: 'password', element: <PasswordSecurity /> },
      { path: 'notifications', element: <NotificationList /> },
      { path: 'privacy-policy', element: <PrivacyPolicy /> },
    ],
  },
  {
    path: '/notifications',
    element: <NotificationList />,
  },
  // 🚫 Catch all undefined or restricted routes
  {
    path: '*',
    element: <Navigate to="/login" replace />,
  },
];
export default routes;
